import React from "react";
import {
  Button,
  Navbar,
  Popover,
  Menu,
  MenuDivider,
  MenuItem,
  Tag
} from "@blueprintjs/core";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

import { withFirebase } from "../Firebase";
import { withAuthentication } from "../Session";

const StyledLink = styled(NavLink)`
  display: block;
  color: #f7f7f8 !important;
  &:hover {
    color: #fff !important;
    text-decoration: none;
  }
  &.active {
    color: #fff !important;
  }
`;

const AppNavbar = ({ authUser, firebase }) => {
  return (
    <Navbar>
      <Navbar.Group align="left">
        <StyledLink to="/live" exact={true}>
          <Button className="bp3-minimal" icon="play" text="Live panel" />
        </StyledLink>
        <StyledLink to="/gallery/">
          <Button className="bp3-minimal" icon="layers" text="Image presets" />
        </StyledLink>
        <StyledLink to="/slideshows/">
          <Button className="bp3-minimal" icon="film" text="Slideshows" />
        </StyledLink>
        <StyledLink to="/scripts/">
          <Button className="bp3-minimal" icon="code-block" text="Scripts" />
        </StyledLink>
      </Navbar.Group>
      <Navbar.Group align="right">
        <Popover
          wrapperTagName="div"
          position="bottom-right"
          content={
            <Menu>
              <MenuItem
                text={
                  <span>
                    DKC Panel
                  </span>
                }
              />
              <MenuItem
                text="No other panels linked to your account"
                disabled
              />
              {authUser === null && (
                <>
                  <MenuDivider />
                  <MenuItem
                    text="Sign in to view your private panels"
                    disabled
                  />
                </>
              )}
            </Menu>
          }
        >
          <Button
            text={
              <span>
                DKC Panel
              </span>
            }
            rightIcon="caret-down"
            style={{ width: "100%" }}
          />
        </Popover>
        <Navbar.Divider />
        {authUser !== null ? (
          <Popover
            interactionKind="hover"
            content={
              <Menu>
                <MenuItem onClick={firebase.doSignOut} text="Logout" icon="log-out"></MenuItem>
              </Menu>
            }
          >
            <Button
              className="bp3-minimal"
              icon="person"
              text={authUser.email}
            />
          </Popover>
        ) : (
          <StyledLink to="/login/">
            <Button
              className="bp3-minimal"
              icon="person"
              text="Unauthenticated"
            />
          </StyledLink>
        )}
      </Navbar.Group>
    </Navbar>
  );
};

export default withAuthentication(withFirebase(AppNavbar));
